import { identifier, serializable } from "serializr"
import util from "@/util"
import Farm from "@/farm/Farm"

export default class FarmEvent {
  @serializable(identifier())
  private readonly uuid: string = util.uuid()

  // Describes the event. If text contains '{variable}', that will be substituted by 'args.variable' from the arguments.
  @serializable
  public text: string

  // When the event happened, in game time.
  @serializable
  public time: number = 0

  // Variables that only matter on event creation

  // A function. Takes an object containing a farm. Uses this to create side-effects on the game world.
  // Returns a string that describes what just happened.
  private readonly action: any

  constructor(action: any = () => {}) {
    this.text = ""
    this.action = action
  }

  takeAction(farm: Farm) {
    this.text = this.action({ farm: farm })
    this.time = farm.state.time
  }

  static milkPriceChangeEvent: () => FarmEvent = () => new FarmEvent((args: any) => {
    let value = (args.farm.state.milkPrice.value) * Math.random()
    value = (Math.random() < 0.5) ? value * (1 / 4) : -value * (1 / 5)
    let actualValue = args.farm.state.milkPrice.addValue(value)
    let text = ""
    if (actualValue > 0) text = `increased by $${util.showNumber(actualValue)}`
    else if (actualValue < 0) text = `decreased by $${util.showNumber(Math.abs(actualValue))}`
    else text = `remained unchanged`

    return `Price of milk has ${text}!`
  })

  /*static milkDemandChangeEvent: () => FarmEvent = () => new FarmEvent((args: any) => {
    let value = (args.farm.state.milkDemand.max) * (0.1 + 0.4 * Math.random())
    let actualValue = args.farm.state.milkDemand.addValue(value)
    let text = ""
    //if (actualValue > 0) text = `increased by $${util.showNumber(actualValue)}`
    //else if (actualValue < 0) text = `decreased by $${util.showNumber(Math.abs(actualValue))}`
    //else text = `remained unchanged`

    return `The demand of milk as gone up by ${util.showNumber(actualValue)}L.`
  })*/
}
